var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgX = function SvgX(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 23 22",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.693 4.13a.67.67 0 0 1 .034.946l-5.425 5.834 5.987 7.97a.669.669 0 0 1-.532 1.07h-3.652a.66.66 0 0 1-.533-.265l-4.214-5.608-5.263 5.661a.67.67 0 0 1-.942.033.67.67 0 0 1-.033-.945l5.424-5.834-5.987-7.97a.67.67 0 0 1 .532-1.07h3.653a.67.67 0 0 1 .532.265l4.214 5.608 5.262-5.661a.667.667 0 0 1 .943-.034m-6.767 7.171a1 1 0 0 1-.052-.069L8.41 5.288H6.426l10.01 13.326h1.984z",
    clipRule: "evenodd"
  })));
};
export default SvgX;